The identifier for the draft that the `PositionProfile` to be updated from.
